export class BaseRenderer {
  data: any = {};
  value: any = '';
  meta: any = {};
}
